function hngImageSrcToLocalFile (img) {
  if (!img || !img.localFile || !img.source_url) {
    return;
  }

  img.source_url = img.localFile.childImageSharp.original.src;
}

module.exports = {
  imageSrcToLocalFile: hngImageSrcToLocalFile,
};



// WEBPACK FOOTER //
// ./src/assets/libs/hngutils.js